/**
 * /frontend/src/features/analytics/api/offerAnalyticsApi.js
 */

import { ANALYTICS_ENDPOINTS } from '../constants/analyticsEndpoints';
import { getJson } from './analyticsApiClient';

/**
 * Fetches offers summary metrics.
 */
export const getOfferSummary = async (request, token, storeId, startDate, endDate) => getJson(
  request,
  ANALYTICS_ENDPOINTS.OFFERS_SUMMARY,
  { storeId, startDate, endDate },
  token,
  'analytics-offers-summary'
);

/**
 * Fetches offer funnel metrics.
 */
export const getOfferFunnel = async (request, token, offerId, startDate, endDate) => getJson(
  request,
  ANALYTICS_ENDPOINTS.OFFERS_FUNNEL(offerId),
  { startDate, endDate },
  token,
  'analytics-offers-funnel'
);

/**
 * Fetches offers comparison metrics.
 */
export const getOfferComparison = async (request, token, storeId, startDate, endDate) => getJson(
  request,
  ANALYTICS_ENDPOINTS.OFFERS_COMPARISON,
  { storeId, startDate, endDate },
  token,
  'analytics-offers-comparison'
);

/**
 * Fetches offers grouped by audience metrics.
 */
export const getOfferByAudience = async (request, token, storeId, startDate, endDate) => getJson(
  request,
  ANALYTICS_ENDPOINTS.OFFERS_BY_AUDIENCE,
  { storeId, startDate, endDate },
  token,
  'analytics-offers-by-audience'
);
